import Vue from 'vue';
import Vuex from 'vuex';
import quote from './modules/quote';
import user from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    quote,
    user,
  },
});
